import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { lazy, Suspense } from "react";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Layout } from "@/components/layout/Layout";
import Home from "./pages/Home";

// Lazy-load all non-home routes to keep the initial JS bundle small (LCP/TBT).
const ServicesIndex = lazy(() => import("./pages/ServicesIndex"));
const ServiceDetail = lazy(() => import("./pages/ServiceDetail"));
const BezirkeIndex = lazy(() => import("./pages/BezirkeIndex"));
const BezirkDetail = lazy(() => import("./pages/BezirkDetail"));
const Contact = lazy(() => import("./pages/Contact"));
const ProblemsIndex = lazy(() => import("./pages/ProblemsIndex"));
const ProblemDetail = lazy(() => import("./pages/ProblemDetail"));
const BlogIndex = lazy(() => import("./pages/BlogIndex"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const Preise = lazy(() => import("./pages/Preise"));
const Impressum = lazy(() => import("./pages/Impressum"));
const Datenschutz = lazy(() => import("./pages/Datenschutz"));
const NotFound = lazy(() => import("./pages/NotFound.tsx"));

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Suspense fallback={<div className="min-h-screen bg-background" />}>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/leistungen" element={<ServicesIndex />} />
                <Route path="/leistungen/:slug" element={<ServiceDetail />} />
                <Route path="/bezirke" element={<BezirkeIndex />} />
                <Route path="/bezirke/:slug" element={<BezirkDetail />} />
                <Route path="/probleme" element={<ProblemsIndex />} />
                <Route path="/probleme/:slug" element={<ProblemDetail />} />
                <Route path="/ratgeber" element={<BlogIndex />} />
                <Route path="/ratgeber/:slug" element={<BlogPost />} />
                <Route path="/preise" element={<Preise />} />
                <Route path="/impressum" element={<Impressum />} />
                <Route path="/datenschutz" element={<Datenschutz />} />
                <Route path="/kontakt" element={<Contact />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
            </Suspense>
          </BrowserRouter>
        </TooltipProvider>
      </LanguageProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
